import "./base.css"

import { FieldErrors, UseFormRegisterReturn } from "react-hook-form"

import { A } from "../../utils/router"
import CheckboxStyles from "./checkbox.module.css"
import React from "react"
import ReactMarkdown from "react-markdown"
import WrapWithError from "./wrap-with-error"
import classNames from "classnames"
import rehypeExternalLinks from "rehype-external-links"
import rehypeRaw from "rehype-raw"
import rehypeSanitize from "rehype-sanitize"
import { useRequiredMark } from "./required-mark"

type CheckboxProps = {
    error?: FieldErrors
    register: UseFormRegisterReturn
    disabled?: boolean
    required?: boolean
    label: string
    variant?: string
}

const Checkbox = ({ error, register, disabled, required, label, variant }: CheckboxProps) => {
    const showRequiredMark = useRequiredMark()

    return (
        <div
            className={classNames(
                CheckboxStyles.block,
                {
                    [CheckboxStyles.error]: error?.[register.name],
                },
                variant
            )}
        >
            <WrapWithError error={error?.[register.name]} id={register.name}>
                <input
                    {...register}
                    type="checkbox"
                    id={register.name}
                    className="hiddenInput"
                    disabled={disabled}
                    required={required}
                    aria-invalid={!!error?.[register.name]}
                    aria-errormessage={"err-" + register.name}
                />
                <label htmlFor={register?.name}>
                    <ReactMarkdown
                        rehypePlugins={[
                            rehypeRaw,
                            rehypeSanitize,
                            [rehypeExternalLinks, { target: "_blank", rel: "noopener noreferrer" }],
                        ]}
                        components={{
                            p: ({ children }) => <>{children}</>,
                            a: ({ children, href }) => <A href={href}>{children}</A>,
                        }}
                    >
                        {label}
                    </ReactMarkdown>
                    {required && showRequiredMark && <span className="required"> *</span>}
                </label>
            </WrapWithError>
        </div>
    )
}

export default Checkbox
